import { SiteCurrency } from './locale'

export interface OrderGiftcard {
  currency: SiteCurrency
  bonusAmount: string
  amount: string
  note: string
  id: number
}

export const initialOrderGiftcard: OrderGiftcard = {
  currency: SiteCurrency.euro,
  bonusAmount: '20',
  amount: '100',
  note: '',
  id: 1,
}

export enum deliveryStyle {
  sendToSender = 'send_to_sender',
  sendToReceiver = 'send_to_receiver',
  digital = 'digital',
}

export interface GiftcardOrder {
  giftcards: OrderGiftcard[]
  activeGiftcard: number
  deliveryStyle: deliveryStyle

  step: number

  name?: string
  nameSender?: string
  email?: string
  emailSender?: string
  zipcode?: string
  city?: string
  street?: string
  houseNumber?: string
  houseNumberExt?: string
  addressLine2?: string
  phone?: string
  deliveryDate?: string
  christmasTermsAndConditions: boolean
}

const initialGiftcardOrder: GiftcardOrder = {
  giftcards: [initialOrderGiftcard],
  activeGiftcard: 1,
  deliveryStyle: deliveryStyle.digital,
  step: 1,
  christmasTermsAndConditions: false,
}

export default initialGiftcardOrder
